<template>
    <div>
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <table class="w-full">
            <thead class="bg-lightGray h-11">
            <tr class="font-weight-bold">
                <td class="px-3">#</td>
                <td>{{ $t('autoOrder.period') }}</td>
                <td>{{ $t('autoOrder.amount') }}</td>
                <td>{{ $t('autoOrder.sum') }}</td>
                <td class="px-3">{{ $t('autoOrder.status') }}</td>
                <td>{{ $t('date') }}</td>
                <td>{{ $t('detailed') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(order, index) in getOrders" :key="index" class="h-11">
                <td class="px-3">{{ order.id }}</td>
                <td>{{ order.period }} {{ $t('autoOrder.daily') }}</td>
                <td>{{ order.autoOrderItems.length }} {{ $t('unitOfMeasure.pc') }}</td>
                <td>{{ showCurrencyById(3, order.sum) }}</td>
                <td class="px-3">
                    <div :style="{'background-color': howBgColor(order.isOrdered)}" class="py-1 rounded text-center">
                        {{ getOrderStatus(order.isOrdered) }}
                    </div>
                </td>
                <td>{{ dateTimeFormat(order.createdAt) }}</td>
                <td >
                    <img src="/images/read-more.png" alt="" class="h-8 cursor-pointer" @click="showMore(order.id)">
                </td>
            </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "OrderListTable",
    components: {Modal},
    mixins: [dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            modalText: '',
        }
    },
    computed: {
        ...mapGetters(['getOrders'])
    },
    methods: {
        ...mapActions(['fetchOrder']),
        getOrderStatus(isOrdered) {
            return isOrdered ? this.$t('autoOrder.ordered') : this.$t('autoOrder.prepared')
        },
        howBgColor(isOrdered) {
            return isOrdered ? '#D4F8E5' : '#FFCDB8'
        },
        showMore(id) {
            this.$root.showOverlay = true
            this.fetchOrder(id)
                .then(() => {
                    this.$root.showOverlay = false
                    this.$i18nHelper.toUrl('orders/' + id)
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        }
    },
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
